import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Status } from "./useApi";

const BASE = process.env.REACT_APP_BACKEND_URL;
const ACCEPT = "image/png,image/jpeg,image/svg+xml,image/webp,.svg";
const E0 = { nombre: "", deporte: "", enlace: "" };

const svgToPng = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const w = img.naturalWidth || 600, h = img.naturalHeight || 600, s = 600 / Math.max(w, h);
    const c = document.createElement("canvas");
    c.width = Math.round(w * s); c.height = Math.round(h * s);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error("svg"))), "image/png");
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("svg")); };
  img.src = url;
});

const Campos = ({ f, setF, id }) => (
  <>
    <label>Nombre<input value={f.nombre} maxLength={120} onChange={(e) => setF({ ...f, nombre: e.target.value })} data-testid={`ali-nombre-${id}`} /></label>
    <label>Deporte o área<input value={f.deporte} maxLength={80} onChange={(e) => setF({ ...f, deporte: e.target.value })} data-testid={`ali-deporte-${id}`} /></label>
    <label>Instagram o web (opcional)<input value={f.enlace} maxLength={300} placeholder="https://" onChange={(e) => setF({ ...f, enlace: e.target.value })} data-testid={`ali-enlace-${id}`} /></label>
  </>
);

const Fila = ({ a, onChange }) => {
  const [f, setF] = useState({ nombre: a.nombre, deporte: a.deporte, enlace: a.enlace });
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); await onChange(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const upload = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    run(async () => {
      const isSvg = file.type === "image/svg+xml" || /\.svg$/i.test(file.name);
      const blob = isSvg ? await svgToPng(file).catch(() => { throw new Error("No se pudo leer el SVG"); }) : file;
      const fd = new FormData();
      fd.append("file", blob, isSvg ? "logo.png" : file.name);
      await api.post(`/aliados/${a.id}/logo`, fd);
    }, "Logo actualizado");
  };
  return (
    <div className="alirow" data-testid={`ali-row-${a.id}`}>
      <div className="clogo">{a.logo ? <img src={`${BASE}${a.logo}`} alt={`Logo de ${a.nombre}`} data-testid={`ali-logo-${a.id}`} /> : <span className="note">Sin logo</span>}</div>
      <div className="frm alifields"><Campos f={f} setF={setF} id={a.id} /></div>
      <div className="aliacts">
        <button className="btn btn-sol" disabled={busy} onClick={() => run(() => api.put(`/aliados/${a.id}`, { ...f, orden: a.orden }), "Cambios guardados")} data-testid={`ali-save-${a.id}`}>Guardar</button>
        <label className="btn xbtn" data-testid={`ali-upload-label-${a.id}`}>Subir logo<input type="file" accept={ACCEPT} hidden onChange={upload} disabled={busy} data-testid={`ali-upload-${a.id}`} /></label>
        {a.logo && <button className="btn xbtn" disabled={busy} onClick={() => run(() => api.delete(`/aliados/${a.id}/logo`), "Logo quitado")} data-testid={`ali-logo-del-${a.id}`}>Quitar logo</button>}
        <button className="btn xbtn" disabled={busy} onClick={() => window.confirm(`¿Quitar a ${a.nombre} de la página?`) && run(() => api.delete(`/aliados/${a.id}`), "Club quitado")} data-testid={`ali-del-${a.id}`}>Quitar club</button>
      </div>
    </div>
  );
};

export const AliadosView = () => {
  const [list, setList] = useState(null);
  const [error, setError] = useState("");
  const [nuevo, setNuevo] = useState(E0);
  const load = useCallback(async () => {
    try { const { data } = await api.get("/aliados"); setList(data); setError(""); } catch (e) { setError(errMsg(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const crear = async (e) => {
    e.preventDefault();
    try { await api.post("/aliados", nuevo); toast.success("Club agregado"); setNuevo(E0); await load(); } catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <div data-testid="aliados-view">
      <div className="panel">
        <h4>Clubes e instituciones aliadas</h4>
        <p className="note" style={{ marginTop: 0 }}>Sube solo logos entregados por cada club, con su permiso. Se aceptan PNG, JPG, SVG o WebP; se reducen a 300 px y se guardan como WebP. Mientras no haya logo, la página muestra las iniciales.</p>
        <form className="frm alifields" onSubmit={crear} data-testid="ali-new-form">
          <Campos f={nuevo} setF={setNuevo} id="nuevo" />
          <button className="btn btn-sol" type="submit" data-testid="ali-new-submit">Agregar club</button>
        </form>
      </div>
      {!list ? <Status data={list} error={error} /> : (
        <div className="alilist" data-testid="ali-list">
          {list.map((a) => <Fila key={`${a.id}-${a.logo}`} a={a} onChange={load} />)}
        </div>
      )}
    </div>
  );
};
